import {Button, Dialog, DialogActions, DialogContent, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import SaveIcon from "@mui/icons-material/Save";
import {LoadingButton} from "@mui/lab";

interface Props {
    open: boolean;
    onClose?: () => void;
    mode: string;
    onConfirm: (action:string) => void;
    isLoading?: boolean;
};

export default function EquipmentDialog({
                                                         open,
                                                         onClose,
                                                         mode,
                                                         onConfirm,
                                                        isLoading = false
                                                     }: Props) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    px: 1,
                }
            }}
        >
            <DialogContent sx={{ pt: 2.5 }}>
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: 20 }}>
                            Tem certeza que deseja excutar essa ação?
                        </Typography>

                        <Typography sx={{ mt: 1, fontSize: 16, color: "text.secondary", lineHeight: "18px" }}>
                            Essa ação finalizará e reconhecerá todos os alarmes ativos deste equipamento. A ação pode demorar alguns minutos. Deseja continuar?
                        </Typography>
                    </Box>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2.5 }}>
                <Button
                    variant="text"
                    onClick={onClose}
                    disabled={isLoading}
                    sx={{ fontWeight: 700 }}
                >
                    CANCELAR
                </Button>

                {isLoading ?
                    <LoadingButton
                        sx={{fontWeight: 800}}
                        loading
                        loadingPosition="end"
                        endIcon={<SaveIcon sx={{fontSize: 20}}/>}
                    >
                        CARREGANDO...
                    </LoadingButton>
                :
                    <Button
                        variant="contained"
                        onClick={() => {onConfirm(mode)}}
                        disabled={isLoading}
                        sx={{ fontWeight: 800 }}
                    >
                        CONTINUAR
                    </Button>}

            </DialogActions>
        </Dialog>
    )}